import { AppProvider } from '@shopify/polaris';
import { QueryClientProvider } from '@tanstack/react-query';
import { ModalContextProvider } from 'contexts/ModalProvider';
import ShopifyGraphQLGatewaySwitch from 'contexts/ShopifyGraphQLGatewaySwitch';
import DebugFab from 'features/debug/components/DebugFab';
import GoogleTagManager from 'features/google-tag-manager/components/google-tag-manager';
import SetupGuideStepDoneActionListener from 'features/google-tag-manager/components/setup-guide-step-done-action-listener';
import VirtualPageViewActionListener from 'features/google-tag-manager/components/virtual-page-view-action-listener';
import { GlobalErrorConfiguration } from 'hooks/globalErrorUtils';
import useAppBridgeConfig from 'hooks/useAppBridgeConfig';
import useCLSToSentryLog from 'hooks/useCLSToSentryLog';
import useOpenParamDispatcher from 'hooks/useOpenParamDispatcher';
import usePolarisLanguage from 'hooks/usePolarisLanguage';
import { SidebarNavigationEmbedded } from 'layouts/mainframe/SidebarNavigationEmbedded';
import { Outlet } from 'react-router';
import { store } from 'redux/store';
import FoxpostService from 'services/ppoints/FoxpostService';
import GLSService from 'services/ppoints/GLSService';
import MPLService from 'services/ppoints/MPLService';
import PackageProviderService from 'services/settings/ppoints/PackageProviderService';
import { queryClient } from 'utils/queryClient';
import Maintenance from './components/maintenance/Maintenance';
import IfCondition from './components/shared/If-condition';
import useMaintenanceException from './hooks/maintenance/useMaintenanceException';
import './react-i18next-init';
import embeddedAppUtils from './utils/embeddedAppUtils';

PackageProviderService.injectStore(store);
PackageProviderService.injectStore(store);
MPLService.injectStore(store);
FoxpostService.injectStore(store);
GLSService.injectStore(store);
embeddedAppUtils.injectStore(store);

function AppMain() {
    const { hasMaintenance, isMaintenanceException } = useMaintenanceException();
    const { config } = useAppBridgeConfig();

    const polarisLanguage = usePolarisLanguage();

    useOpenParamDispatcher();

    useCLSToSentryLog();

    const appJsx = (
        <ShopifyGraphQLGatewaySwitch>
            <ModalContextProvider>
                <GoogleTagManager />
                <VirtualPageViewActionListener />
                <SetupGuideStepDoneActionListener />
                {embeddedAppUtils.isAppEmbedded() && <SidebarNavigationEmbedded />}
                <AppProvider i18n={polarisLanguage}>
                    <GlobalErrorConfiguration />
                    {/* <ModalWrapper /> */}
                    <Outlet />
                </AppProvider>
                <DebugFab />
            </ModalContextProvider>
        </ShopifyGraphQLGatewaySwitch>
    );

    return (
        <IfCondition condition={true}>
            <IfCondition condition={hasMaintenance && !isMaintenanceException}>
                <Maintenance />
            </IfCondition>
            <IfCondition condition={!hasMaintenance || isMaintenanceException}>
                <QueryClientProvider client={queryClient}>
                    <>{appJsx}</>
                </QueryClientProvider>
            </IfCondition>
        </IfCondition>
    );
}

export default AppMain;
